import { render } from "./TestimonialsComponent.vue?vue&type=template&id=071ff154"
import script from "./TestimonialsComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3987420887/src/bt-website-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__